// extracted by mini-css-extract-plugin
export default {"logout":"Page_logout__lnNrQ"};